import React from "react";
import PropTypes from 'prop-types';
import SearchComponent from './SearchComponent';
import AddButtonComponent from '../button/AddButtonComponent';

const SearchAddComponent = ({
    handleSearchText,
    searchHandleNavigate,
    handleKeyPress,
    handleClickAddAction,
}) => {
    return (
        <div className="flex flex-col sm:flex-row items-center w-full gap-2">
            {/* Empty Space for Alignment */}
            <div className="hidden sm:block flex-1"></div>
            {/* Search Bar */}
            {handleSearchText &&
                <div className="w-full sm:w-auto flex-1">
                    <div className="relative w-full max-w-md">
                        <SearchComponent
                            onChange={handleSearchText}
                            onClick={searchHandleNavigate}
                            onKeyPress={handleKeyPress}
                        />
                    </div>
                </div>
            }
            {handleClickAddAction &&
                < div className="w-full sm:w-auto flex justify-end mb-3">
                    <AddButtonComponent onClick={handleClickAddAction}>
                        Add
                    </AddButtonComponent>
                </div>
            }
        </div >
    );
};

SearchAddComponent.propTypes = {
    handleSearchText: PropTypes.func,
    searchHandleNavigate: PropTypes.func,
    handleKeyPress: PropTypes.func,
    handleClickAddAction: PropTypes.func,
};

export default SearchAddComponent;
